import PropTypes from 'prop-types';
import { Stack } from '@mui/material';

import { QualityEvaluationItem } from './QualityEvaluationItem';

const styles = {
  scale: {
    width: '100%',
    height: 68,
  },
};

export const QualityEvaluationScale = ({
  hideValue = false,
  id = 'quality-evaluation-scale',
  options,
  selectedValue = null,
  onChangeSelectedValue = null,
  customStyles = null,
}) => {
  const roundedValue = selectedValue === null ? null : Math.round(selectedValue);

  return (
    <Stack direction="row" sx={[styles.scale, customStyles]}>
      {options.map((color, index) => {
        const value = index + 1;
        const isSelected = value === roundedValue;
        const cursorOffset = isSelected ? selectedValue - value : 0;
        const handleClick = onChangeSelectedValue ? () => onChangeSelectedValue(value) : onChangeSelectedValue;

        return (
          <QualityEvaluationItem
            id={id}
            key={value}
            hideValue={hideValue}
            value={value}
            isSelected={isSelected}
            cursorOffset={cursorOffset}
            handleClick={handleClick}
            color={color}
          />
        );
      })}
    </Stack>
  );
};

QualityEvaluationScale.propTypes = {
  hideValue: PropTypes.bool,
  id: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedValue: PropTypes.number,
  onChangeSelectedValue: PropTypes.func,
  customStyles: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};
